import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { EditsquaresRoutingModule } from './editsquares-routing.module';
import { EditsquaresComponent } from './editsquares.component';

@NgModule({
  declarations: [EditsquaresComponent
  ],
  imports: [
    EditsquaresRoutingModule,
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
  ],
  entryComponents: []
})
export class EditsquaresModule {}
